import { defineMessages } from 'react-intl-next';

export default defineMessages({
	multipleAppsConflicted: {
		id: 'ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted',
		defaultMessage:
			'Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin.',
		description:
			'A information that gets displayed when UI modifications misconfiguration was detected',
	},
});
